// This file contains material which is the pre-existing property of Psycle
// Interactive Limited.
// Copyright (c) 2018 Psycle Interactive. All rights reserved.

/* globals window */

// Import third party modules
import angular from 'angular';

const MODULE_NAME = 'analytics';
angular.module(MODULE_NAME, [])

    .factory('analyticsService', ($location) => {

      // ---------------------------------------------------------------------- //
      // Methods

      /**
     * @param {string} gaCode
     */
      function init(gaCode) {
        gaId = gaCode;

        // Initialise Google Tag Manager before adding script to DOM
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({
          'gtm.start': new Date().getTime(),
          'event': 'gtm.js',
        });

        const gtmScript = document.createElement('script');
        gtmScript.type = 'text/javascript';
        gtmScript.async = true;
        gtmScript.src = `https://www.googletagmanager.com/gtm.js?id=${ gaId }`;
        document.body.appendChild(gtmScript);
      }

      /**
     * @param {string} location (optional)
     */
      function trackPageView(location = $location.absUrl()) {
        if (window.dataLayer) {
          window.dataLayer.push({
            event: 'page_view',
            pagePath: location,
          });
        }
      }

      /**
     * @param {string} sectionId (optional) should be supplied when navigation is by scroll
     * @param {string} location (optional)
     */
      function trackNavigation(sectionId = null, location = $location.absUrl()) {
        if (window.dataLayer) {
          window.dataLayer.push({
            event: 'internal_click',
            eventParams: {
              linkDomain: window.location.hostname,
              linkUrl: `${location.endsWith('/') ? location.slice(0, -1) : location}${sectionId ? `#${sectionId}` : ''}`,
            }}, {eventParams: undefined});
        }
      }

      function formSubmit(formName) {
        if (window.dataLayer) {
          window.dataLayer.push({
            event: 'form_submit',
            eventParams: {
              formName,
            }}, {eventParams: undefined});
        }
      }

      // ---------------------------------------------------------------------- //
      // Public
      const analyticsService = {
        init: init,
        trackPageView: trackPageView,
        trackNavigation: trackNavigation,
        formSubmit: formSubmit,
      };

      // ------------------------------------------------------------------ //
      // Private
      let gaId = undefined;
      return analyticsService;
    });

export default MODULE_NAME;
